import React from 'react';
import type GroupingType from '../constants/GroupingType';
import useGroupingData from '../hooks/useGroupingData';
// eslint-disable-next-line import/no-cycle
import GroupedOpportunitiesDataList from './GroupedOpportunitiesDataList';
import GroupedOpportunitiesQueryProvider from './GroupedOpportunitiesQueryProvider';
import OpportunitySummaries from './OpportunitySummaries';

export default function GroupedOpportunities({ type }: { type: GroupingType }) {
  const groupingData = useGroupingData(type);
  /**
   * Add padding to bottom of container div the UI does not sit at the very bottom
   * of the page. There is some collapsing margins nonsense going on with the page
   * container and the accordions used in `<GroupedOpportunitiesDataList>`, and time
   * is short atm.
   */
  return (
    <div className="pb-6">
      <OpportunitySummaries />

      <div className="grid gap-6">
        {groupingData.map(({ id, name, prefix }) => (
          <GroupedOpportunitiesQueryProvider
            key={id}
            sortingPrefix={`grp_${prefix}`}
            paginationPrefix={`grp_${prefix}`}
          >
            <GroupedOpportunitiesDataList
              key={id}
              header={name}
              id={id}
              type={type}
            />
          </GroupedOpportunitiesQueryProvider>
        ))}
      </div>
    </div>
  );
}
